module.exports = __webpack_public_path__ + "img/52.9a0a26b6.png";